import React from "react";
import Explainer from "../ExplainerModal";

const PolicyDirectoryExplainer = () => {
  return (
    <Explainer
      title="📂 Policy Directory Explainer"
      content={
        <>
          <p>
            The <strong>Policy Directory</strong> serves as a central repository for all policies being tracked on the platform. It provides an overview of each policy’s status, progress, and associated details.
          </p>

          <h3 style={{ fontSize: "18px", fontWeight: "bold", marginTop: "15px", color: "#333" }}>
            🔍 Key Features
          </h3>
          <p>📌 <strong>Agri-Food System:</strong> Identifies the sector the policy belongs to.</p>
          <p>📌 <strong>Current Stage:</strong> Displays the stage the policy is currently in, from initiation to implementation.</p>
          <p>⚠️ <strong>Status Indicators:</strong> Highlights whether a policy is <span style={{ color: 'red' }}>Off Track</span> and/or <span style={{ color: 'orange' }}>Delayed</span>.</p>
          <p>👥 <strong>Engaged Partners:</strong> Lists the stakeholders involved in the policy process.</p>
          <p>📊 <strong>Policy Progress Score (%):</strong> Represents the percentage of milestones completed.</p>
          <p>📈 <strong>Progress Rating:</strong> A qualitative measure based on the policy progress score.</p>

          <h3 style={{ fontSize: "18px", fontWeight: "bold", marginTop: "15px", color: "#333" }}>
            📊 Progress Rating Breakdown
          </h3>
          <table style={{ borderCollapse: 'collapse', width: '100%', textAlign: 'left', marginTop: '10px' }}>
            <thead>
              <tr style={{ backgroundColor: '#f0f0f0' }}>
                <th style={{ borderBottom: '2px solid black', padding: '8px' }}>Score Range (%)</th>
                <th style={{ borderBottom: '2px solid black', padding: '8px' }}>Progress Rating</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ padding: '8px' }}>0 - 30</td>
                <td style={{ padding: '8px', color: '#ff0000', fontWeight: 'normal', }}>🔴 Minimal</td>
              </tr>
              <tr>
                <td style={{ padding: '8px' }}>31 - 60</td>
                <td style={{ padding: '8px', color: '#ff6f61', fontWeight: 'normal'}}>🟠 Moderate</td>
              </tr>
              <tr>
                <td style={{ padding: '8px' }}>61 - 80</td>
                <td style={{ padding: '8px', color: '#d98f00', fontWeight: 'normal' }}>🟡 Significant</td>
              </tr>
              <tr>
                <td style={{ padding: '8px' }}>81 - 100</td>
                <td style={{ padding: '8px', color: '#008000', fontWeight: 'normal'}}>🟢 Satisfactory</td>
              </tr>
            </tbody>
          </table>

          <h3 style={{ fontSize: "18px", fontWeight: "bold", marginTop: "15px", color: "#333" }}>
            📌 Additional Insights
          </h3>
          <p>📄 <strong>Policy Details:</strong> Provides a description of what the policy entails.</p>
          <p>🔄 <strong>Updates & Emerging Outcomes:</strong> Highlights key developments as the policy progresses.</p>

          <h3 style={{ fontSize: "18px", fontWeight: "bold", marginTop: "15px", color: "#333" }}>
            🧮 Policy Progress Score Calculation
          </h3>
          <p>
            The <strong>Policy Progress Score</strong> is determined using the following formula:
          </p>
          <p style={{ backgroundColor: "#f4f4f4", padding: "10px", borderRadius: "5px", fontFamily: "monospace" }}>
            Policy Progress Score (%) = (Sum of Completed Milestones ÷ Total Milestones) × 100
          </p>
        </>
      }
    />
  );
};

export default PolicyDirectoryExplainer;
